import { Helmet } from 'react-helmet-async';

const siteUrl = process.env.REACT_APP_SITE_URL || 'https://buildorq.com';

const SEOHead = ({
  title,
  absoluteTitle,
  description,
  keywords,
  image,
  imageAlt,
  url,
  type = 'website',
  structuredData,
  noindex = false,
}) => {
  const defaultTitle = 'BuildOrq | Orchestrate the Build';
  const defaultDescription =
    'BuildOrq is a construction operations platform for managing projects, estimates, house plans, documents, materials, inspections, finance, and site activity in one place.';
  const defaultKeywords =
    'BuildOrq, construction management software, project estimations, house plans, materials management, construction finance, site reports';
  const defaultImage = `${siteUrl}/logo.png`;
  const defaultImageAlt = 'BuildOrq logo';

  const seoTitle = absoluteTitle || (title ? `${title} | BuildOrq` : defaultTitle);
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;
  const seoImageAlt = imageAlt || defaultImageAlt;
  const seoUrl = url || siteUrl;
  const robotsContent = noindex ? 'noindex, follow' : 'index, follow';

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="robots" content={robotsContent} />
      <meta name="author" content="BuildOrq" />
      <link rel="canonical" href={seoUrl} />

      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={seoImage} />
      <meta property="og:image:alt" content={seoImageAlt} />
      <meta property="og:image:width" content="536" />
      <meta property="og:image:height" content="192" />
      <meta property="og:url" content={seoUrl} />
      <meta property="og:site_name" content="BuildOrq" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoTitle} />
      <meta name="twitter:description" content={seoDescription} />
      <meta name="twitter:image" content={seoImage} />
      <meta name="twitter:image:alt" content={seoImageAlt} />

      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
